import { render, staticRenderFns } from "./Commercial.vue?vue&type=template&id=2ed211d0&scoped=true&"
import script from "./Commercial.vue?vue&type=script&lang=js&"
export * from "./Commercial.vue?vue&type=script&lang=js&"
import style0 from "./Commercial.vue?vue&type=style&index=0&id=2ed211d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed211d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VContainer,VFlex,VLayout})
